import Text from 'components/3catinfo/Text';
import Boto from 'components/3catinfo/Boto';
import Titol from 'components/3catinfo/Titol';
import Compartir from 'components/3catinfo/Compartir';
import Imatge, { hasImatge } from 'components/3catinfo/Imatge';
import Icona from '../ui/Icona/Icona';
import Enllac from 'components/3catinfo/Enllac';
import BotoSeguir from 'components/3catinfo/BotoSeguir';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './capcalera.module.scss';
import { useState } from 'react';

const ImatgeDreta = (props) => {
    const { hasImatges, imatges } = props;
    return (
        hasImatges && imatges ? (
            <div className={styles.imgBg}>
                <Imatge
                    imatges={imatges}
                    className={styles.bg}
                    tipus='web_capcalera_seccio'
                    aria-hidden='true'
                    layout='fill'
                    objectFit='cover'
                />
            </div>
        ) : (
            <div className={styles.shapeDreta}></div>
        )
    );
};

const getTitol = (props) => {
    const { prefixTitol, titol } = props;
    if (__isEmpty(prefixTitol)) return titol;
    return `${prefixTitol}${titol}`;
};

const Capcalera = (props) => {
    const {
        tipus,
        descripcio,
        mostraAccions,
        tagidint,
        tag,
        imatges,
        segueix,
        compartir,
        linkBreadcrumb,
        titolBreadcrumb,
        tema,
        estil,
        className,
        urlPrograma
    } = props;
    const titol = getTitol(props);
    const [isHovered, setIsHovered] = useState(false);
    const hasImatges = hasImatge(imatges, 'web_capcalera_seccio', null, null);

    const stylesCapcalera = clsx({
        [styles.capcalera]: true,
        [styles.hasImatges]: hasImatges,
        [styles.lite]: tipus === 'lite' || !hasImatges,
        [styles[tema]]: !!tema,
        [styles[estil]]: !!estil,
        [className]: !!className
    });

    const stylesContent = clsx({
        [styles.content]: true,
        [styles.gap]: descripcio || segueix || compartir
    });

    const stylesDescripcio = clsx({
        [styles.descripcio]: true
        //[styles.descripcioAmbImatge]: hasImatges
    });

    const stylesInfo = clsx({
        [styles.info]: true,
        [styles.infoMon3cat]: tema === 'mon3Cat'
    });

    return (
        <div className={stylesCapcalera}>
            {tema !== 'mon3Cat' && <ImatgeDreta hasImatges={hasImatges} titol={titol} imatges={imatges} />}
            {tema === 'mon3Cat' && (
                <div className={styles.formes}>
                    <div></div>
                    <div></div>
                </div>
            )}
            <div className={stylesInfo}>
                <div className={styles.innerWrapper}>
                    <div className={stylesContent}>
                        <div className={styles.contentTitol}>
                            {linkBreadcrumb && titolBreadcrumb && (
                                <Enllac href={linkBreadcrumb} className={styles.breadcrumb}>
                                    <Icona icona='fletxa_simple_esquerra' path='el-temps' className={styles.icona} mida={16} />
                                    <span className={styles.text}>{titolBreadcrumb}</span>
                                </Enllac>
                            )}
                            <Titol tag={tag} titol={titol} tipus='seccio' className={styles.titol} />
                            {descripcio && <Text tag='p' text={descripcio} className={stylesDescripcio} />}
                        </div>
                        {mostraAccions && (
                            <div className={styles.contentShared}>
                                {segueix && (
                                    <div>
                                        <BotoSeguir
                                            //seguint={false}
                                            obreEsquerra={false}
                                            id={tagidint}
                                            textHitAudiencies={titol}
                                            tipologia={'DTY_CATEGORY'}
                                            estil='petit'
                                            enviaApi={true}
                                        />
                                    </div>
                                )}
                                {urlPrograma && (
                                    <div
                                        className={styles.link3cat}
                                        onMouseEnter={() => setIsHovered(true)}
                                        onMouseLeave={() => setIsHovered(false)}
                                    >
                                        <Boto
                                            link={urlPrograma}
                                            estil='link3cat'
                                            className={styles.link3cat}
                                            mida='small'
                                            text='Ves al programa'
                                            icona='ic_linkexterior'
                                            isIconaBlanc={!isHovered}
                                            novaFinestra={true}
                                        />
                                    </div>
                                )}
                                {compartir && (
                                    <div>
                                        <Compartir />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

Capcalera.defaultProps = {
    prefixTitol: '',
    mostraAccions: true,
    segueix: true,
    compartir: true
};

export default Capcalera;
